module.exports = __webpack_public_path__ + "img/img-2.c8fb6049.png";